<template>
  <v-btn icon @click="fnToggleBookmark()" v-if="userTypeCode !== ''">
    <v-icon v-if="isBookmark" color="#a01c2a">mdi-star</v-icon>
    <v-icon v-if="!isBookmark">mdi-star-outline</v-icon>
  </v-btn>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'

export default {
  name: 'Bookmark',
  components: {
  },
  props : {
    service_type_code : String
  },
  data () {
    return {
      isBookmark : false,
      userTypeCode: store.state.token.user_type_code
    }
  },
  mounted () {
    if (!utils.isNull(this.userTypeCode)) {
      this.fnGetBookmark()
    }
  },
  methods: {
    fnGetBookmark(){
      requestApi({
        url: '/user/bookmark/'+this.service_type_code,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.cnt > 0){
              this.isBookmark = true
            }else{
              this.isBookmark = false
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetBookmark()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnToggleBookmark(){
      requestApi({
        url: '/user/bookmark/'+this.service_type_code,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.cnt > 0){
              this.fnRmvBookmark()
            }else{
              this.fnAddBookmark()
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnToggleBookmark()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnAddBookmark(){
      requestApi({
        url: '/user/bookmark/',
        method: 'POST',
        data: { service_type_code : this.service_type_code },
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('component.bookmark.fields.msg_add_success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)

            this.fnGetBookmark()
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnAddBookmark()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnRmvBookmark(){
      requestApi({
        url: '/user/bookmark/'+this.service_type_code,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            let option = {
              text : this.$t('component.bookmark.fields.msg_rmv_success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)

            this.fnGetBookmark()
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnRmvBookmark()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }

  }
}

</script>